module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/normalize-wheel/index.js
// module id = 128
// module chunks = 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19